import { memo } from 'react';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
} from '@mui/material';

import FormActionButtons from 'components/ui/form/FormActionButtons';
import useFormSubmit from 'hooks/useFormSubmit';
import useNotification from 'hooks/useNotification';

const ObjectAddKeyModal = ({ open, setOpen, selected, setSelected }) => {
  const { t } = useTranslation();
  const sendNotification = useNotification();
  const { submit, isSubmitting } = useFormSubmit();
  const { id: object_id } = selected;
  const formik = useFormik({
    initialValues: {
      object_id,
    },
    onSubmit: async (values) => {
      submit(
        { type: 'post', contentType: 'simple' },
        values,
        `/admin/object/keygenerate/${object_id}`,
        values.name,
        null,
        true,
        (res) => {
          formik.setFieldValue('key', res?.data);
        },
      );
    },
  });

  const handleClose = () => {
    setOpen(false);
    setSelected({});
    formik.resetForm();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='lg'
      disableEscapeKeyDown={true}
      className='!base-border !shadow-none'
      PaperProps={{
        className: '!shadow-none !base-border min-w-[500px]',
      }}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!bg-[#CDCDCDC7] !text-center !mb-2 !border-b !border-b-[#E6E6E6]'
      >
        <span className='pr-5 font-semibold text-[21px] text-[#374957]'>
          {t('common.table.keyword')}
        </span>
      </DialogTitle>

      <DialogContent>
        {isSubmitting ? (
          <div className='circular-progress-box py-5 absolute inset-0 z-10 bg-[rgba(255,255,255,.6)]'>
            <CircularProgress size={35} />
          </div>
        ) : (
          ''
        )}
        <form onSubmit={formik.handleSubmit}>
          <Grid
            container
            spacing={{ xs: 2, sm: 3, lg: 3 }}
            rowSpacing={1}
            columns={{ xs: 12, sm: 12, lg: 12 }}
          >
            <Grid item={true} sm={12} xs={12}>
              <div className='flex justify-between gap-1'>
                <div className='grow border h-[40px] text-ellipsis whitespace-nowrap rounded-md px-2 flex items-center'>
                  {formik.values.key || ''}
                </div>
                <Button
                  onClick={() => {
                    navigator.clipboard.writeText(formik?.values?.key);
                    sendNotification({
                      msg: t('common.alerts.success.copied'),
                      variant: 'success',
                    });
                  }}
                  variant='outlined'
                  color='info'
                  className='!rounded-md'
                >
                  <i className='bi bi-copy' />
                </Button>
              </div>
            </Grid>
            <Grid item={true} sm={12} xs={12}>
              <div className='flex justify-end'>
                <FormActionButtons
                  delay={0}
                  isSubmitting={isSubmitting}
                  formType='dialog'
                  saveTitle='common.button.generateKeygen'
                  setOpen={setOpen}
                  reset={formik.resetForm}
                />
              </div>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default memo(ObjectAddKeyModal);
